import ButtonLink from "plos/src/components/links/ButtonLink";
import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
  entryId?: number;
}

const ReportCrestButton: React.FC<IProps> = ({ entryId }) => {
  const { t } = useTranslation();
  if (!entryId) {
    return null;
  }
  return (
    <ButtonLink
      to={`/help/report-badge?${entryId ? `entryId=${entryId}` : ""}`}
      appearance="outlined"
      size="small"
      fullWidth
    >
      {t("reportCrestButton", "Report Offensive Team Badge")}
    </ButtonLink>
  );
};
export default ReportCrestButton;
